export default `<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.24219 4.24268L12.7275 12.728" stroke="#141A77"/>
<path d="M4.24219 12.728L12.7275 4.24275" stroke="#141A77"/>
</svg>
`
